import moment from "moment";
import { useState, useEffect } from "react";

import FormReservar from "../components/form-reservar";
import useModal from "../../../../core/hooks/use-modal";
import Calendario from "../../../../core/ui/components/Calendar/Calendario";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
    obtenerReservaPorId,
    obtenerReservas,
} from "../../services/reservas-service";
import useUser from "../../../../core/hooks/use-user";
import { toast } from "../../../../core/helpers/message-helper";
import ModalVerReserva from "../components/modal-ver-reserva";

const Reservar = () => {
    const { sedeId, recursoId } = useOutletContext();
    const navigate = useNavigate();
    const { getUserData } = useUser();
    const user = getUserData();

    const [reservas, setReservas] = useState([]);
    const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
    const [tipoCalendario, setTipoCalendario] = useState("dayGridMonth");

    const modalReservas = useModal({
        data: { reserva: {} },
        title: "Crear Reserva",
    });

    const modalVerReserva = useModal({
        data: {
            reserva: {},
            mostrarBotonCancelar: false,
        },
    });

    useEffect(() => {
        if (sedeId == null || recursoId == null) return navigate("/reservas");
    });

    useEffect(async () => {
        const resp = await obtenerReservas({ sedeId });
        if (!resp.status) return toast.error(resp.message);

        const reservas = resp.data.map((reserva) => {
            const fechaInicioReserva = `${reserva.fecha}T${reserva.hora_inicio}`;
            const fechaFinReserva = `${reserva.fecha}T${reserva.hora_fin}`;

            return {
                ...reserva,
                title: reserva.asunto,
                allDay: false,
                id: reserva.id,
                className: "bg-danger",
                start: fechaInicioReserva,
                end: fechaFinReserva,
            };
        });

        setReservas(reservas);
    }, []);

    const onFechaPulsada = (fechaPulsada) => {
        if (tipoCalendario == "dayGridMonth") {
            setFechaSeleccionada(fechaPulsada);
            setTipoCalendario("timeGridDay");
        } else {
            const fecha = moment(fechaSeleccionada).format("YYYY-MM-DD");
            const hora_inicio = moment(fechaPulsada).format("HH:mm:ss");
            const hora_fin = moment(fechaPulsada)
                .add(30, "minutes")
                .format("HH:mm:ss");
            // Mostrar modal
            modalReservas.open({
                data: {
                    reserva: {
                        fecha,
                        hora_inicio: hora_inicio,
                        hora_fin: hora_fin,
                    },
                },
            });
        }
    };

    const onReservaCreada = (reserva) => {
        const fechaInicioReserva = `${reserva.fecha}T${reserva.hora_inicio}`;
        const fechaFinReserva = `${reserva.fecha}T${reserva.hora_fin}`;

        setReservas((prev) => [
            ...prev,
            {
                title: reserva.asunto,
                allDay: false,
                id: reserva.id,
                className: "bg-danger",
                start: fechaInicioReserva,
                end: fechaFinReserva,
            },
        ]);
        setTipoCalendario("dayGridMonth");
        setFechaSeleccionada(null);
    };

    const onClickEvento = async (evento) => {
        const datosEvento = evento.event.extendedProps;

        const resp = await obtenerReservaPorId(datosEvento.id);
        if (!resp.status) return toast.error(resp.message);

        modalVerReserva.open({
            data: {
                reserva: resp.data,
                mostrarBotonCancelar: user.id == datosEvento.persona_id,
            },
        });
    };

    const horasDeNegocio = [
        {
            daysOfWeek: [1, 2, 3, 4, 6],
            startTime: "06:00",
            endTime: "22:00",
        },
        {
            daysOfWeek: [5],
            startTime: "06:00",
            endTime: "07:00",
        },
        {
            daysOfWeek: [5],
            startTime: "11:00",
            endTime: "22:00",
        },
    ];

    return (
        <>
            <Calendario
                tipoVista={tipoCalendario}
                eventosSeleccionados={reservas}
                fechaInicio={moment().add(1, "days").format("YYYY-MM-DD")}
                fechaFin={moment().add(1, "months").format("YYYY-MM-DD")}
                onFechaPulsada={onFechaPulsada}
                onEventoClick={onClickEvento}
                fechaSeleccionada={fechaSeleccionada}
                horasDeNegocio={horasDeNegocio}
            />
            <FormReservar modalState={modalReservas} onSave={onReservaCreada} />
            <ModalVerReserva modalState={modalVerReserva} />
        </>
    );
};

export default Reservar;
